import { Link } from 'react-router-dom';
import { categoryMeta, type ContentCategory } from '@/mocks/content';

const order: ContentCategory[] = ['news', 'entertainment', 'lifestyle'];

const accents: Record<ContentCategory, string> = {
  news: 'bg-primary-50 text-primary-700',
  entertainment: 'bg-accent-100 text-accent-900',
  lifestyle: 'bg-secondary-100 text-secondary-900',
};

export default function CategoryEntries({ counts }: { counts: Record<ContentCategory, number> }) {
  return (
    <section className="mx-auto w-full max-w-[1280px] px-4 py-10 md:px-6 md:py-14">
      <div className="mb-7 flex flex-wrap items-end justify-between gap-3">
        <div>
          <h2 className="font-heading text-xl font-bold text-foreground-950 md:text-2xl">快捷分类入口</h2>
          <p className="mt-1.5 text-sm text-foreground-600">三大内容板块，一键直达你关心的领域</p>
        </div>
      </div>
      <div className="grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-3">
        {order.map((key) => {
          const meta = categoryMeta[key];
          return (
            <Link
              key={key}
              to={meta.path}
              className="group flex flex-col rounded-lg border border-background-200/70 bg-background-50 p-6 transition-all duration-300 hover:-translate-y-1 hover:border-primary-200"
            >
              <div className="mb-5 flex items-center justify-between">
                <span className={`flex h-14 w-14 items-center justify-center rounded-lg ${accents[key]}`}>
                  <i className={`${meta.icon} text-2xl`}></i>
                </span>
                <span className="text-xs text-foreground-500">
                  共 <strong className="text-foreground-900">{counts[key]}</strong> 篇内容
                </span>
              </div>
              <h3 className="mb-2 font-heading text-lg font-bold text-foreground-950">{meta.name}频道</h3>
              <p className="mb-5 flex-1 text-sm leading-relaxed text-foreground-600">{meta.desc}</p>
              <span className="flex items-center gap-1 text-sm font-medium text-primary-600">
                进入频道
                <i className="ri-arrow-right-line transition-transform duration-300 group-hover:translate-x-1"></i>
              </span>
            </Link>
          );
        })}
      </div>
    </section>
  );
}